export const C = {
  bg: "#080C14",
  bg2: "#0C1320",
  surface: "#121A2B",
  surface2: "#19233A",
  line: "#27324C",
  lineSoft: "#1E2840",
  text: "#EAF1FB",
  muted: "#8696B0",
  faint: "#5C6B86",
  turf: "#2DE36B",
  turfDim: "#159B52",
  gold: "#F5B301",
  live: "#FF3B47",
};

export const RARITY = {
  commun: {
    label: "Common",
    color: "#9CA7B8",
    glow: "rgba(156,167,184,.40)",
    odds: 80,
  },
  rare: {
    label: "Rare",
    color: "#3B82F6",
    glow: "rgba(59,130,246,.55)",
    odds: 15,
  },
  epic: {
    label: "Epic",
    color: "#A855F7",
    glow: "rgba(168,85,247,.60)",
    odds: 4,
  },
  ultra: {
    label: "Legendary",
    color: "#F5B301",
    glow: "rgba(245,179,1,.65)",
    odds: 1,
  },
};

export const RARITY_ORD = ["ultra", "epic", "rare", "commun"] as const;

export const RARITY_MULT: Record<string, number> = {
  commun: 1,
  rare: 2.3,
  epic: 4.2,
  ultra: 7,
};
